import React from "react";
import { FiZap, FiCpu, FiUsers, FiActivity, FiTrendingUp } from "react-icons/fi";

const items = [
  {
    icon: FiZap,
    title: "Problem-First, Context Aware AI",
    description: "Designed around your custom problem.",
  },
  {
    icon: FiCpu,
    title: "Edge + Cloud AI",
    description: "Enables real time inference at scale.",
  },
  {
    icon: FiUsers,
    title: "Human-in-the-loop",
    description: "AI augments your team to make swift, data-backed decisions.",
  },
  {
    icon: FiActivity,
    title: "Predictive Anomaly Detection",
    description: "Right insights at the right time to prevent regressions.",
  },
  {
    icon: FiTrendingUp,
    title: "Continuous Learning",
    description: "AI that continuously learns from usage — keeping the feedback loop closed.",
  },
];

const HowWeLeverageAI = () => {
  return (
    <section id="how-we-leverage-ai" className="py-24 px-6 lg:px-20 bg-[#0D1117]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-['IBM_Plex_Mono'] text-[#F07023] text-xs tracking-[0.3em] uppercase">
            04 / How We Leverage AI
          </span>
          <h2 className="text-white text-[clamp(1.5rem,2.5vw,2.75rem)] font-[700] mt-4 leading-tight">
            AI Augmented Solutions
          </h2>
          <div className="w-12 h-px bg-[#F07023] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-5xl mx-auto">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="group border-t-2 border-[#F07023]/25 pt-6 transition-colors duration-300 hover:border-[#F07023]"
              >
                <div className="flex items-center gap-3 mb-3">
                  <Icon className="text-[#F07023] text-xl flex-shrink-0" />
                  <h3 className="font-[600] text-white">{item.title}</h3>
                </div>
                <p className="text-[#8892A4] text-sm leading-relaxed pl-7">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowWeLeverageAI;
